export const SKINS = {
  general: 'general',
  standard: 'standard',
  danger: 'danger',
  success: 'success',
  neutral: 'neutral',
  neutralLight: 'neutralLight',
  warning: 'warning',
  warningLight: 'warningLight',
  urgent: 'urgent',
  neutralStandard: 'neutralStandard',
  neutralSuccess: 'neutralSuccess',
  neutralDanger: 'neutralDanger',
  premium: 'premium',
};
